import { createContext, useContext, useState, useEffect } from 'react'
import localesData from '../locales.json'

const LOCALES = ['en', 'fr', 'pt', 'es', 'zh', 'zh-HK', 'mn', 'ko', 'ja', 'vi']

// 页面标题翻译
const pageTitles = {
  en: {
    home: 'CCICM - Professional International Commercial Debt Services',
    services: 'CCICM - Professional International Commercial Debt Services | Our Services',
    about: 'CCICM - Professional International Commercial Debt Services | About Us',
    contact: 'CCICM - Professional International Commercial Debt Services | Contact Us',
    default: 'CCICM - Professional International Commercial Debt Services'
  },
  fr: {
    home: 'CCICM - Services professionnels internationaux de dette commerciale',
    services: 'CCICM - Services professionnels internationaux de dette commerciale | Nos services',
    about: 'CCICM - Services professionnels internationaux de dette commerciale | À propos',
    contact: 'CCICM - Services professionnels internationaux de dette commerciale | Contactez-nous',
    default: 'CCICM - Services professionnels internationaux de dette commerciale'
  },
  pt: {
    home: 'CCICM - Serviços profissionais internacionais de dívida comercial',
    services: 'CCICM - Serviços profissionais internacionais de dívida comercial | Nossos serviços',
    about: 'CCICM - Serviços profissionais internacionais de dívida comercial | Sobre nós',
    contact: 'CCICM - Serviços profissionais internacionais de dívida comercial | Contate-nos',
    default: 'CCICM - Serviços profissionais internacionais de dívida comercial'
  },
  es: {
    home: 'CCICM - Servicios profesionales internacionales de deuda comercial',
    services: 'CCICM - Servicios profesionales internacionales de deuda comercial | Nuestros servicios',
    about: 'CCICM - Servicios profesionales internacionales de deuda comercial | Sobre nosotros',
    contact: 'CCICM - Servicios profesionales internacionales de deuda comercial | Contáctenos',
    default: 'CCICM - Servicios profesionales internacionales de deuda comercial'
  },
  zh: {
    home: 'CCICM - 专业的国际商业债务服务提供商',
    services: 'CCICM - 专业的国际商业债务服务提供商 | 我们的服务',
    about: 'CCICM - 专业的国际商业债务服务提供商 | 关于我们',
    contact: 'CCICM - 专业的国际商业债务服务提供商 | 联系我们',
    default: 'CCICM - 专业的国际商业债务服务提供商'
  },
  'zh-HK': {
    home: 'CCICM - 專業的國際商業債務服務提供商',
    services: 'CCICM - 專業的國際商業債務服務提供商 | 我們的服務',
    about: 'CCICM - 專業的國際商業債務服務提供商 | 關於我們',
    contact: 'CCICM - 專業的國際商業債務服務提供商 | 聯絡我們',
    default: 'CCICM - 專業的國際商業債務服務提供商'
  },
  mn: {
    home: 'CCICM - Олон улсын коммерцийн өрийн мэргэжлийн үйлчилгээ',
    services: 'CCICM - Олон улсын коммерцийн өрийн мэргэжлийн үйлчилгээ | Бидний үйлчилгээ',
    about: 'CCICM - Олон улсын коммерцийн өрийн мэргэжлийн үйлчилгээ | Бидний тухай',
    contact: 'CCICM - Олон улсын коммерцийн өрийн мэргэжлийн үйлчилгээ | Холбоо барих',
    default: 'CCICM - Олон улсын коммерцийн өрийн мэргэжлийн үйлчилгээ'
  },
  ko: {
    home: 'CCICM - 전문 국제 상업 부채 서비스',
    services: 'CCICM - 전문 국제 상업 부채 서비스 | 우리의 서비스',
    about: 'CCICM - 전문 국제 상업 부채 서비스 | 회사 소개',
    contact: 'CCICM - 전문 국제 상업 부채 서비스 | 문의하기',
    default: 'CCICM - 전문 국제 상업 부채 서비스'
  },
  ja: {
    home: 'CCICM - プロフェッショナルな国際商業債務サービス',
    services: 'CCICM - プロフェッショナルな国際商業債務サービス | サービス',
    about: 'CCICM - プロフェッショナルな国際商業債務サービス | 会社概要',
    contact: 'CCICM - プロフェッショナルな国際商業債務サービス | お問い合わせ',
    default: 'CCICM - プロフェッショナルな国際商業債務サービス'
  },
  vi: {
    home: 'CCICM - Dịch vụ nợ thương mại quốc tế chuyên nghiệp',
    services: 'CCICM - Dịch vụ nợ thương mại quốc tế chuyên nghiệp | Dịch vụ của chúng tôi',
    about: 'CCICM - Dịch vụ nợ thương mại quốc tế chuyên nghiệp | Về chúng tôi',
    contact: 'CCICM - Dịch vụ nợ thương mại quốc tế chuyên nghiệp | Liên hệ',
    default: 'CCICM - Dịch vụ nợ thương mại quốc tế chuyên nghiệp'
  }
}

// 检测用户语言
function detectUserLanguage() {
  if (typeof navigator === 'undefined') return 'en'

  const browserLang = navigator.language || navigator.userLanguage

  // 精确匹配
  if (LOCALES.includes(browserLang)) {
    return browserLang
  }

  // 语言前缀匹配
  const langPrefix = browserLang.split('-')[0].toLowerCase()

  // 特殊处理中文 - 需求 1.1: 简体中文系统也默认使用英文
  if (langPrefix === 'zh') {
    // 检查是否是繁体中文地区
    if (browserLang.toLowerCase().includes('hk') || browserLang.toLowerCase().includes('tw')) {
      return 'zh-HK'
    }
    // 简体中文系统默认使用英文
    return 'en'
  }

  // 匹配其他语言
  for (const locale of LOCALES) {
    if (locale.startsWith(langPrefix)) {
      return locale
    }
  }

  // 默认返回英文
  return 'en'
}

// 从 localStorage 获取保存的语言
function getStoredLanguage() {
  if (typeof localStorage === 'undefined') return null
  const stored = localStorage.getItem('ccicm-language')
  if (stored && LOCALES.includes(stored)) {
    return stored
  }
  return null
}

const LanguageContext = createContext(null)

export function LanguageProvider({ children }) {
  const [currentLang, setCurrentLang] = useState(() => {
    return getStoredLanguage() || detectUserLanguage()
  })

  const [translations, setTranslations] = useState(localesData[currentLang] || localesData.en)

  // 保存语言选择到 localStorage
  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('ccicm-language', currentLang)
    }
    // 更新翻译
    setTranslations(localesData[currentLang] || localesData.en)
  }, [currentLang])

  const t = (key) => {
    const keys = key.split('.')
    let value = translations
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        return key
      }
    }
    return value || key
  }

  // 获取页面标题
  const getPageTitle = (page) => {
    const titles = pageTitles[currentLang] || pageTitles.en
    return titles[page] || titles.default
  }

  return (
    <LanguageContext.Provider value={{
      t,
      lang: currentLang,
      setLanguage: setCurrentLang,
      locales: LOCALES,
      data: translations,
      getPageTitle
    }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useTranslation() {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useTranslation must be used within LanguageProvider')
  }
  return context
}

// 自定义 Hook：自动更新页面标题
export function usePageTitle(pageKey) {
  const { getPageTitle, lang } = useTranslation()

  useEffect(() => {
    const title = getPageTitle(pageKey)
    document.title = title
  }, [pageKey, lang, getPageTitle])

  return null
}
